import { fetchJson } from '../lib/fetchJson';
import type { PlaceResult } from '../types/search';

interface GeocodeResponse {
  query: string;
  results: { id: string; title: string; subtitle: string; matchedAddress?: string; lat: number; lng: number }[];
}

/** US Census geocoder through /api/geocode. No autocomplete: call on submit. */
export async function geocode(query: string, signal?: AbortSignal): Promise<PlaceResult[]> {
  const q = query.trim();
  if (!q) return [];
  const data = await fetchJson<GeocodeResponse>(`/api/geocode?q=${encodeURIComponent(q)}`, { signal, timeoutMs: 20_000 });
  return (data.results ?? []).map((r) => ({
    id: r.id,
    title: r.title,
    subtitle: r.subtitle,
    location: { lat: r.lat, lng: r.lng },
  }));
}
